import React from "react";
import { FormControl } from "react-bootstrap";
import { normalizeId, getFormattedDate } from "../helpers/utility";

const TextInput = ({
  id,
  title,
  onChange,
  onFormChange,
  value,
  preValue,
  className = "",
  textArea = false,
  hint = "",
  required = false,
  variant = "text",
  onClick,
  disabled = false,
  onKeyPress,
  min,
  max,
  style = {},
  name,
  size,
  rows = 2,
}) => {
  let defaultValue = value || preValue;
  if (variant === "date" && defaultValue) {
    const date = new Date(defaultValue);
    defaultValue = getFormattedDate(date);
  }
  return (
    <FormControl
      id={id || normalizeId(title)}
      type={variant}
      onChange={(e) => {
        if (onChange) onChange(e);
        if (onFormChange) onFormChange(e);
      }}
      defaultValue={defaultValue}
      className={className}
      as={textArea ? "textarea" : "input"}
      placeholder={hint}
      required={required}
      onClick={onClick}
      disabled={disabled}
      onKeyPress={onKeyPress}
      min={min}
      max={max}
      style={style}
      name={name}
      size={size}
      rows={rows}
    ></FormControl>
  );
};

export default TextInput;
